import Vue from "vue";

export const AnalyticsState = {
  comparisonGraphs: [],
  totalComparisonGraphs: 0
};

export const AnalyticsGetters = {
  comparisonGraphs: state => {
    return state.comparisonGraphs;
  },
  totalComparisonGraphs: state => {
    return state.totalComparisonGraphs;
  }
};

export const AnalyticsMutations = {
  setComparisonGraph: (state, data) => {
    if (data) {
      const index = state.comparisonGraphs.findIndex(
        i => Number(i.id) === Number(data.id)
      );
      if (index > -1) {
        const arr = [...state.comparisonGraphs];
        arr[index] = data;
        Vue.set(state, "comparisonGraphs", arr);
      }
    }
  },
  setComparisonGraphs: (state, data) => {
    Vue.set(state, "comparisonGraphs", data.comparison_graphs);
    Vue.set(state, "totalComparisonGraphs", data.total_count);
  },
  addComparisonGraph: (state, data) => {
    Vue.set(state, "comparisonGraphs", [...state.comparisonGraphs, data]);
    Vue.set(state, "totalComparisonGraphs", state.totalComparisonGraphs + 1);
  },
  removeComparisonGraph: (state, data) => {
    const arr = state.comparisonGraphs.filter(
      i => Number(i.id) !== Number(data.id)
    );
    Vue.set(state, "comparisonGraphs", arr);
    Vue.set(state, "totalComparisonGraphs", state.totalComparisonGraphs - 1);
  }
};

export const AnalyticsActions = {
  getComparisonGraphs: ({ commit, dispatch }, data = {}) => {
    const params = data.params || "";
    return Vue.axios.secured
      .get(`/api/v1/comparison_graphs${params}`)
      .then(response => {
        commit("setComparisonGraphs", response.data);
        return { success: true, data: response.data.comparison_graphs };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch comparison graphs from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: [] };
      });
  },
  getComparisonGraph: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .get(`/api/v1/comparison_graphs/${data.id}`)
      .then(response => {
        commit("setComparisonGraph", response.data);
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to fetch comparison graph from server.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  createComparisonGraph: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .post("/api/v1/comparison_graphs", {
        comparison_graph: data.comparison_graph
      })
      .then(response => {
        commit("addComparisonGraph", response.data);
        const title = `New comparison graph added`;
        const message = `Success! New comparison graph has been added.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to create comparison graph.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  updateComparisonGraph: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .patch(`/api/v1/comparison_graphs/${data.id}`, {
        comparison_graph: data.comparison_graph
      })
      .then(response => {
        commit("setComparisonGraph", response.data);
        // const title = `Comparison graph updated`;
        // const message = `Success! The comparison graph has been updated.`;
        // dispatch("showToast", { title, message, type: "success" });
        return { success: true, data: response.data };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to update comparison graph.";
        dispatch("showToast", { message, type: "error" });
        return { success: false, data: null };
      });
  },
  deleteComparisonGraph: ({ commit, dispatch }, data = {}) => {
    return Vue.axios.secured
      .delete(`/api/v1/comparison_graphs/${data.id}`)
      .then(response => {
        commit("removeComparisonGraph", data);
        const title = `Comparison graph deleted`;
        const message = `Success! The comparison graph has been deleted.`;
        dispatch("showToast", { title, message, type: "success" });
        return { success: true };
      })
      .catch(error => {
        const err = error.response && error.response.data;
        const message = err || "Unable to delete comparison graph.";
        dispatch("showToast", { message, type: "error" });
        return { success: false };
      });
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/analytics.store.js